(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("webstompobs", [], factory);
	else if(typeof exports === 'object')
		exports["webstompobs"] = factory();
	else
		root["webstompobs"] = factory();
})(global, function() {
return 